import(/* webpackMode: "eager" */ "/vercel/path0/app/spaces/page.tsx");
